import React from 'react';
import cover from '../assets/cover.jpg';
import Newsletter from '../newsletter/Newsletter';
import './Landing.css';

export default function Landing() {
  return (
    <>
      <Newsletter />
      <main id='landing-main'>
        <img
          id='landing-cover'
          src={cover}
          alt='Ghost in the Code book cover'
        />
        <p id='landing-p'>
          <button id='coming-soon-button'>
            <a
              href='https://www.amazon.com/Ghost-Code-Cyberpunk-H-N-Fisher-ebook/dp/B0FY2G7FLF'
              target='_blank'
              rel="noreferrer"
            >
              Purchase
            </a>
          </button>
          <br />
          <br />
          <b>
            In a city where loyalty is a currency and trust is a luxury, who can you rely on when only ghosts remain?
          </b>
          <br />
          <br />
          Alex is a Class Nine Data Wrangler, the best of her kind and a model citizen, poised for promotion. But her ascent up the corporate ladder takes a perilous twist when she’s sent on a clandestine mission to track down a thief who has stolen vital records, and Alex uncovers a shocking truth—she’s been an unwitting pawn in a game of oppression.
          <br />
          <br />
          Determined to reclaim her freedom and make amends, Alex hatches a daring plan to liberate Neo Haven’s citizens from their corporate shackles. But as the authorities close in and her actions spiral into chaos, she realizes that in a city where betrayal lurks around every corner, the line between friend and foe blurs.
          <br />
          <br />
          With her life hanging in the balance, Alex must navigate a treacherous landscape of deceit and manipulation. In a race against time, she must decide who to trust before it’s too late, or risk losing everything. Will she succeed in her fight for freedom, or will she become another ghost in the code?
          <br />
          <br />
          For fans of dystopian thrillers and fast-paced action, "Ghosts in the Code" will keep you on the edge of your seat until the very end.
        </p>
      </main>
    </>
  )
}
